"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.computePercent = computePercent;
exports.showPercent = showPercent;
function computePercent(start, end) {
    return (end - start) / start;
}
function showPercent(pc) {
    return `${Math.round(pc * 100)}%`;
}
//# sourceMappingURL=percent.js.map